module.exports = __webpack_public_path__ + "img/coupon.712ccbb1.png";